import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SignIn from './SignIn'; // Import your sign-in page
import MainLayout from './MainLayout'; // Import the main app layout
import ProtectedRoute from './auth/ProtectedRoute'; // Import the gatekeeper

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public Route: The sign-in page */}
        <Route path="/signin" element={<SignIn />} />

        {/* Protected Route: The main application */}
        <Route
          path="/*" // This will match any route that is not '/signin'
          element={
            <ProtectedRoute>
              {/* --- MODIFICATION: MainLayout is now the direct child --- */}
              <MainLayout />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}